// AdminChatsList
import React from 'react';
import _ from 'lodash';
import axios from 'axios';
import MomentTZ from 'moment-timezone';
import Moment from 'moment';
import DomImage from '../DomImage'

export default class AdminChatsList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      chats: [],
      admin_url : `${this.props.serverUrl}/admin`
    };
  }

  componentWillMount() {
    this.getList();
    setInterval(() => {
      this.getList();
    }, 30000);
  }

  getList() {
    axios.get(
      this.state.admin_url + '/sessions?' + (new Date().getTime()),
      { withCredentials: true })
        .then(response => {
          this.setState({chats: [...response.data]})
        })
        .catch(err => {
          this.setState({error: err+''})
        });
  }

  handleCloseChat(chatId){
    if (window.confirm('Are you sure you want to CLOSE the chat #'+parseInt(chatId)+'?')){
      axios.post(
        this.state.admin_url + '/sessions/' + parseInt(chatId) + '/close?' + (new Date().getTime()),
        {},
        { withCredentials: true })
        .then(response => {
          this.getList();
        })
        .catch(err => {
          this.setState({chats: [], error: err+''})
        });
    }
  }

  handleExportChat(chatId, e) {
    e.preventDefault();
    if (window.confirm('Are you sure you want to EXPORT the chat #' + parseInt(chatId) + '?')) {
      e.target.submit();
    }
  }

  handleReopenChat(chatId, e) {
    if (window.confirm('Are you sure you want to re-open the chat #' + parseInt(chatId) + '?')) {
      axios.post(
        this.state.admin_url + '/chat-session/' + parseInt(chatId) + '/reopen?' + (new Date().getTime()),
        {},
        { withCredentials: true })
        .then(response => {
          this.getList();
        })
        .catch(err => {
          this.setState({ chats: [], error: err + '' })
        });
    }
  }

  handleDeleteChat(chatId){
    if (window.confirm('Are you sure you want to DELETE the chat #' + parseInt(chatId) + '?')) {
      axios.delete(
        this.state.admin_url + '/sessions/' + parseInt(chatId) + '?' + (new Date().getTime()),
        { withCredentials: true })
        .then(response => {
          this.getList();
        })
        .catch(err => {
          this.setState({ chats: [], error: err + ''})
        });
    }
  }

  render() {

    let nb_chats_opened = 0,
      nb_chats_closed = 0;

    return (

      <div>
        <span className='alert'>{this.state.error}</span>


        <button className='btn btn-primary btn-round fright' onClick={this.getList.bind(this)}><i className='pe-7s-refresh'></i></button>
        <div className='clear'></div>

        <h2>Live-Chat sessions currently in progress</h2>
        <table className="content list" cellSpacing="1" cellPadding="0">
              <thead>
                <tr>
                  <th width="70">Chat Id</th>
                  <th>Title</th>
                  <th width="135">Users</th>
                  <th width="135">Activity</th>
                  <th width="170">Actions</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.chats.map((chat, index) => {
                if (!_.isNil(chat.closed) && chat.closed){
                  return;
                }
                nb_chats_opened++;
                return (
                  <tr key={'o'+index}>
                    <td className='small'>
                      <a href={'/'+chat.id} target="_blank">#{chat.id}</a>
                    </td>
                    <td>
                      <DomImage src={chat.logoUrl} className='client_logo fleft' />
                      <span className='small'>{MomentTZ(chat.startDate).tz('Europe/Paris').format('MMM Do YYYY HH:mm')}</span>
                      <br/>
                      <span className='title'>{chat.title}</span>
                    </td>
                    <td className='tabled'>
                      <table cellSpacing="0" cellPadding="0" className='content'>
                        <thead>
                          <tr>
                            <th>Insiders</th>
                            <th>Visitors</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{chat.numberOfConnectedInsiders}</td>
                            <td>{(chat.numberOfConnectedUsers - chat.numberOfConnectedInsiders)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td className='tabled'>
                      <table cellSpacing="0" cellPadding="0" className='content'>
                        <thead>
                          <tr>
                            <th>Questions</th>
                            <th>Messages</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{chat.numberOfThreads}</td>
                            <td>{chat.numberOfMessages}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <button className='btn btn-warn' onClick={this.handleCloseChat.bind(this, chat.id)}>Close chat</button>
                      <a className='btn btn-secondary' href={`${this.state.admin_url}/sessions/${chat.id}/export`} target="_blank">View JSON</a>
                    </td>
                  </tr>
                )
              })
            }
              </tbody>
          </table>
        {
            (() => {
            if (!nb_chats_opened) {
              return <p className="alert tc">No Open Live Chats.</p>
            }
          })()
          }

          <div className='space'></div>

        <h2>Live-Chat sessions ended and still in cache (waiting for export)</h2>
        <table className="content list" cellSpacing="1" cellPadding="0">
          <thead>
            <tr>
              <th width="70">Chat Id</th>
              <th>Title</th>
              <th width="135">Activity</th>
              <th width="170">Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.chats.map((chat, index) => {
                if (_.isNil(chat.closed) || !chat.closed){
                  // If not closed, we return.
                  return;
                }
                nb_chats_closed++;
                return (
                  <tr key={'c' + index}>
                    <td className='small'>#{chat.id}</td>
                    <td>
                      <DomImage src={chat.logoUrl} className='client_logo fleft' />
                      <span className='small'>{MomentTZ(chat.startDate).tz('Europe/Paris').format('MMM Do YYYY HH:mm')}</span>
                      <br/>
                      <span className='title'>{chat.title}</span>
                    </td>
                    <td className='tabled'>
                      <table cellSpacing="0" cellPadding="0" className='content'>
                        <thead>
                          <tr>
                            <th>Questions</th>
                            <th>Messages</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{chat.numberOfThreads}</td>
                            <td>{chat.numberOfMessages}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <form
                        method='POST'
                        action={this.state.admin_url+'/sessions/'+chat.id+'/export'}
                        onSubmit={this.handleExportChat.bind(this, chat.id)}
                      >
                        <button className='btn btn-primary' type='submit'>Export</button>
                      </form>
                      <button className='btn btn-primary' onClick={this.handleReopenChat.bind(this, chat.id)} type='submit'>Reopen</button>
                      <a className='btn btn-secondary' href={process.env.SERVER_URL + '/admin/sessions/'+chat.id+'/export'} target="_blank">View JSON</a>
                      <a className='btn btn-secondary' href={process.env.SERVER_URL + '/admin/chat-session/'+chat.id+'/survey-csv'}>Download Survey</a>
                      <button className='btn btn-warn' onClick={this.handleDeleteChat.bind(this, chat.id)}>Delete from cache</button>
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </table>
          {
            (() => {
            if (!nb_chats_closed){
              return <p className="alert tc">No ended Live Chats.</p>
            }
          })()
          }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/admin/AdminChatsList.jsx